export default __webpack_public_path__ + "static/media/peoples.e3bb01d8.svg";